import { render, staticRenderFns } from "./ShopifyOrders.vue?vue&type=template&id=d922dc7a&"
import script from "./ShopifyOrders.vue?vue&type=script&lang=js&"
export * from "./ShopifyOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopifyOrders.vue"
export default component.exports